<template>
  <div>
    <a href="#" class="alink" color="success" @click="triggerModal">
        <v-icon color="warning">mdi-account-arrow-up</v-icon>Promote / Demote Students
    </a>
    <v-dialog
      v-model="dialog"
     max-width="800px"
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-title class="modal-card-title text-h6 font-weight-bold">
          <v-icon left>mdi-account-arrow-up</v-icon>
          Promote / Demote Students
          <v-spacer></v-spacer>
          <v-btn icon class="modal-close-btn" @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-6 text-center">
                <!-- Let user decide section -->
                <v-row>
                    <v-col>
                        <v-btn color="success" rounded elevation="2" @click="promoteByClass"><v-icon left>mdi-account-group</v-icon>Class By Class</v-btn>
                    </v-col>
                    <v-col>
                        <v-btn color="primary" rounded elevation="2" @click="promoteByStudent"><v-icon left>mdi-account-arrow-right</v-icon>Student By Student</v-btn>
                    </v-col>
                </v-row>

                <!-- Class by Class Promotion -->
                <v-form v-if="pbc" v-model="valid">
                    <v-container>
                    <v-row>
                        <v-col cols="12">                            
                            <v-chip color="yellow"> <strong>Class by Class Promotion a PREMIUM service. Each Student Promoted or Demoted will consume 1 TOKEN</strong></v-chip>  
                        </v-col>
                        <v-col
                        cols="12"
                        md="6"
                        >
                        <v-select
                        :items="classes"
                        item-text="class"
                        item-value="class_id"
                        label="Move Students FROM:"
                        v-model="form.from_class_id"
                        outline
                        :rules="[v => !!v || 'Class need to be selected!']"
                        required
                        ></v-select>
                        </v-col>

                        <v-col
                        cols="12"
                        md="6"
                        >
                        <v-select
                        :items="classes"
                        item-text="class"
                        item-value="class_id"
                        label="Move Students TO:"
                        v-model="form.to_class_id"
                        outline
                        :rules="[v => !!v || 'Class need to be selected!']"
                        required
                        ></v-select>
                        </v-col>
                        <v-col
                        cols="12"
                        md="12"
                        >
                        <v-btn color="primary" rounded elevation="2" class="px-6" @click="promoteStudents" :disabled="!valid"><v-icon left>mdi-swap-horizontal</v-icon>Move To New Class</v-btn>
                        </v-col>
                    </v-row>
                    </v-container>
                </v-form>
                
                <!-- Student by Student Promotion -->
                <v-form v-if="pbs" v-model="valid">
                    <v-container>
                    <v-row>
                        <v-col
                        cols="12"
                        md="6"
                        >
                        <v-select
                        :items="classes"
                        item-text="class"
                        item-value="class_id"
                        label="Move Students FROM:"
                        v-model="form.from_class_id"
                        @change="fetchStudents(form.from_class_id)"
                        outline
                        :rules="[v => !!v || 'Class need to be selected!']"
                        required
                        ></v-select>
                        </v-col>

                        <v-col
                        cols="12"
                        md="6"
                        >
                        <v-select
                        :items="classes"
                        item-text="class"
                        item-value="class_id"
                        label="Move Students TO:"
                        v-model="form.to_class_id"
                        outline
                        :rules="[v => !!v || 'Class need to be selected!']"
                        required
                        ></v-select>
                        </v-col>
                        <v-col
                        cols="12"
                        md="12"
                        >
                        <v-select
                        :items="students"
                        item-text="name"
                        item-value="student_id"
                        label="Select Student(s):"
                        v-model="form.student_ids"                        
                        chips
                        multiple
                        outline
                        :rules="[(v => !!v) && ((v) =>  v.length>0) || 'Students need to be selected!']"
                        required
                        ></v-select>
                        </v-col>

                        <v-col
                        cols="12"
                        md="12"
                        >
                        <v-btn color="primary" rounded elevation="2" class="px-6" @click="promoteStudents" :disabled="!valid"><v-icon left>mdi-swap-horizontal</v-icon>Move Students</v-btn>
                        </v-col>
                    </v-row>
                    </v-container>
                </v-form>
                
                <v-divider class="my-4"></v-divider>
                <v-card-subtitle class="caption">Do this ONLY after setting new School SESSION</v-card-subtitle>

                <v-btn outlined rounded @click="closeDialog">
                    <v-icon left>mdi-close</v-icon>
                    Close
                </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
</div>
</template>

<script>
import axios from 'axios';
    export default {
        name: 'PromoteDemoteStudents',
        props:[
            'classes','authToken','school'
        ],
        data () {
        return {
            dialog: false,
            form: {},
            students: [],
            pbc:false,
            pbs:false,
            valid:true,
        }
    },
    methods: {
        triggerModal(){
            this.dialog = true
        },
        closeDialog() {
            this.dialog = false;
        },
        fetchStudents (classId){
            let loader = this.$loading.show()
            axios.get(process.env.VUE_APP_BASEURL+'/students?school_id='+this.school.school_id+'&class_id='+classId,
            {
                headers: 
                {
                    'Authorization': 'Bearer '+this.authToken
                }
            })
            .then((response) => {
                this.students =  response.data.data     
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
                loader.hide()
            });
        },
        promoteStudents (){
            let loader = this.$loading.show()
            axios.post(process.env.VUE_APP_BASEURL+'/promotions?school_id='+this.school.school_id,this.form,
            {
                headers: 
                {
                    'Authorization': 'Bearer '+this.authToken
                }
            })
            .then((response) => {
                this.$toast.success(response.data.message, {
                    timeout: 5000
                });    
                this.$emit('promoted', 'yes');   
                this.$store.dispatch('fetchTokens', this.school.school_id);         
            })
            .catch((error) => {
                this.$toast.error(error.response ? error.response.data.message : 'Network Error, Please try again few minutes', {
                    timeout: 5000
                });
            })
            .finally(() => {
                loader.hide()
            });
        },
        promoteByClass (){
            this.pbc = true;
            this.pbs = false;
            this.form = {}
        },
        promoteByStudent (){
            this.pbs = true;
            this.pbc = false;
            this.form = {}
        }
    }
  }
</script>

<style scoped>
.alink{
    text-decoration: none;
    font-weight: bolder;
}
</style>